export default class ConfigManager<T> {
  constructor(private defaultConfig: T, private providedConfig: Partial<T>) {}

  get mergedConfig(): T {
    return { ...this.defaultConfig, ...this.providedConfig };
  }
}
